<app-pias-layout>
    <div pias-layout-content>
        <!-- ═══════════ Page head ═══════════ -->
        <div class="page-header-section">

            <!-- Left Content -->
            <div class="page-header-left">

                <div class="header-icon-badge">
                    <mat-icon>post_add</mat-icon>
                </div>

                <div class="title-wrapper">
                    <h4 class="page-header">
                        {{ pageTitle }}
                    </h4>
                </div>
            </div>

        </div>

        <div class="compose-grid" [class.is-split]="previewOpen">

            <!-- ═══════════ Application form ═══════════ -->
            <div class="compose-col">

                @if (setSprinner()) {
                <div class="pias-spinner">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
                }

                <form class="compose-inner" [class.is-narrow]="!previewOpen" [formGroup]="adFg">

                    <!-- ---- Name of campaign / document ---- -->
                    <div class="field">
                        <label class="field-label" for="ad-title">Name of campaign / document</label>
                        <input id="ad-title" type="text" class="field-box" formControlName="title" maxlength="160"
                            placeholder="Enter the campaign or document a name"
                            [class.is-invalid]="hasError('title')" />
                        @if (hasError('title')) {
                        <p class="field-error">Give the campaign or document a name</p>
                        }
                    </div>

                    <!-- ---- Branch ---- -->
                    <!-- <div class="field">
                        <span class="field-label">Branch name</span>
                        <mat-form-field class="field-select" subscriptSizing="dynamic"
                            [class.is-invalid]="hasError('branch')">
                            <mat-select formControlName="branch" placeholder="Select the branch">
                                @for (branch of branchId; track branch.branchid) {
                                <mat-option [value]="branch.branchid">{{ branch.branchname }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if (hasError('branch')) {
                        <p class="field-error">Select the branch raising this application</p>
                        }
                    </div> -->
                    <!-- ---- Branch ---- -->
                    <div class="field">
                        <label class="field-label" for="branch-name">
                            Branch name
                        </label>

                        <input id="branch-name" type="text" class="field-box" [value]="branchName" readonly
                            aria-readonly="true" />
                    </div>

                    <!-- ---- Type of marketing material ---- -->
                    <!-- The application form's abbreviation table: the code is what is stored, the
                         full term is shown beside it so nobody has to memorise 26 of them. -->
                    <div class="field">
                        <span class="field-label">Type of marketing material</span>
                        <mat-form-field class="field-select" subscriptSizing="dynamic"
                            [class.is-invalid]="hasError('materialType')">
                            <mat-select formControlName="materialType" panelClass="mr-material-type-panel"
                                placeholder="Select the type of material">
                                <!-- Without a trigger the closed select shows the option's raw text,
                                     where the two spans run together as "NPANewspaper Article". -->
                                <mat-select-trigger>
                                    @if (selectedMaterialType; as type) {
                                    <span class="type-trigger">
                                        <span class="type-trigger-code">{{ type.materialKeyword }}</span>
                                        <span class="type-trigger-term">{{ type.materialTitle }}</span>
                                    </span>
                                    }
                                </mat-select-trigger>
                                @for (type of materialTypeId; track type.marketingMaterialId) {
                                <mat-option [value]="type.marketingMaterialId">
                                    <span class="type-code">{{ type.materialKeyword }}</span>
                                    <span class="type-term">{{ type.materialTitle }}</span>
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if (hasError('materialType')) {
                        <p class="field-error">Select the type of marketing material</p>
                        }
                    </div>

                    <!-- ---- Attached material ---- -->
                    <div class="field">
                        <div class="field-head">
                            <span class="field-label">Attach material</span>
                            @if (isPptRequired) {
                            <span class="text-danger">PPT is required</span>
                            }


                            <!-- Preview belongs to the material, so it is toggled from here. -->
                            <button type="button" class="field-action" [class.is-on]="previewOpen"
                                matTooltip="Preview the attached material" (click)="togglePreview()">
                                <mat-icon>{{ previewOpen ? 'visibility_off' : 'visibility' }}</mat-icon>
                                Preview
                            </button>
                        </div>

                        <div class="upload-card" [class.is-dragover]="isDragOver" (dragover)="onDragOver($event)"
                            (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

                            @if (materials.length) {
                            @for (material of materials; track material.attachment.id) {
                            <div class="upload-row">
                                @if (material.kind === 'image') {
                                <img class="upload-thumb" [src]="material.attachment.url"
                                    [alt]="material.attachment.fileName" />
                                } @else {
                                <span class="upload-thumb is-doc" [attr.data-tone]="material.tone">
                                    <mat-icon>{{ material.icon }}</mat-icon>
                                </span>
                                }

                                <div class="upload-text">
                                    <div class="upload-name">{{ material.attachment.fileName }}</div>
                                    <div class="upload-meta">{{ material.meta }}</div>
                                    <div class="upload-progress"><span></span></div>
                                </div>

                                <button type="button" class="upload-remove" matTooltip="Remove"
                                    (click)="removeMaterial(material)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                            }

                            <div class="upload-replace">
                                <label class="replace-button">
                                    <input type="file" hidden multiple [accept]="ACCEPTED_FILE_TYPES"
                                        (change)="onFileSelected($event)" />
                                    Add another file
                                </label>
                            </div>
                            } @else {
                            <label class="upload-dropzone">
                                <input type="file" hidden multiple [accept]="ACCEPTED_FILE_TYPES"
                                    (change)="onFileSelected($event)" />
                                <mat-icon>cloud_upload</mat-icon>
                                <span class="dropzone-title">Drop the material here, or browse</span>
                                <span class="dropzone-hint">Up to 10MB per file, 50MB for video</span>
                            </label>
                            }

                            <div class="upload-foot">
                                <span class="upload-foot-label">Accepted:</span>
                                <span class="upload-formats">
                                    @for (format of ACCEPTED_FORMATS; track format) {
                                    <span class="format-chip">{{ format }}</span>
                                    }
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- ---- Recipients / dissemination ---- -->
                    <!-- The three cells of the application form's dissemination table. -->
                    <div class="field-triple">
                        <div class="field">
                            <div class="field-head">
                                <label class="field-label" for="ad-recipients">
                                    Target recipient(s)
                                </label>
                            </div>
                            <input id="ad-recipients" type="text" class="field-box" formControlName="targetRecipients"
                                maxlength="200" placeholder="e.g. existing clients, prospects"
                                [class.is-invalid]="hasError('targetRecipients')" />
                            @if (hasError('targetRecipients')) {
                            <p class="field-error">State who the material will be sent to</p>
                            }
                        </div>

                        <div class="field">
                            <div class="field-head">
                                <label class="field-label" [attr.for]="useDisseminationNote ? 'ad-dissemination-note'
                                    : 'ad-dissemination-date'">
                                    Expected date of dissemination
                                </label>

                                <!-- No date to give? Write it in words instead. -->
                                <button type="button" class="field-action is-link" (click)="toggleDisseminationNote()">
                                    <mat-icon>{{ useDisseminationNote ? 'event' : 'add_comment' }}</mat-icon>
                                    {{ useDisseminationNote ? 'Use a date' : 'Add comment' }}
                                </button>
                            </div>

                            @if (useDisseminationNote) {
                            <input id="ad-dissemination-note" type="text" class="field-box"
                                formControlName="disseminationNote" maxlength="200"
                                placeholder="e.g. immediate upon approval"
                                [class.is-invalid]="hasError('disseminationNote')" />
                            @if (hasError('disseminationNote')) {
                            <p class="field-error">State when the material will go out</p>
                            }
                            } @else {
                            <!-- DD/MM/YYYY via the moment adapter, as everywhere else in the app —
                                 the native date input rendered the browser's own format and sat its
                                 picker icon off the boxes beside it. -->
                            <mat-form-field class="field-select field-date" subscriptSizing="dynamic"
                                [class.is-invalid]="hasError('expectedDisseminationDate')">
                                <input id="ad-dissemination-date" matInput [matDatepicker]="disseminationPicker"
                                    formControlName="expectedDisseminationDate" [min]="minDisseminationDate"
                                    placeholder="DD/MM/YYYY" />
                                <mat-datepicker-toggle matIconSuffix [for]="disseminationPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #disseminationPicker></mat-datepicker>
                            </mat-form-field>
                            @if (hasError('expectedDisseminationDate')) {
                            <p class="field-error">Pick a date, or add a comment instead</p>
                            }
                            }
                        </div>

                        <div class="field">
                            <div class="field-head">
                                <label class="field-label" for="ad-mode">
                                    Mode of dissemination
                                </label>
                            </div>
                            <input id="ad-mode" type="text" class="field-box" formControlName="modeOfDissemination"
                                maxlength="200" placeholder="e.g. email, hardcopy, newspaper"
                                [class.is-invalid]="hasError('modeOfDissemination')" />
                            @if (hasError('modeOfDissemination')) {
                            <p class="field-error">State how the material will be distributed</p>
                            }
                        </div>
                        <!-- <div class="marketing-questions">

                            <div class="marketing-question">
                                <span class="question-text">
                                    1. Is there any product/ plan being mentioned in the marketing collateral?
                                </span>

                                <div class="question-options">
                                    <mat-checkbox [checked]="marketingAnswers[1] === 'Yes'"
                                        (change)="marketingAnswers[1] = $event.checked ? 'Yes' : ''">
                                        Yes
                                    </mat-checkbox>

                                    <mat-checkbox [checked]="marketingAnswers[1] === 'No'"
                                        (change)="marketingAnswers[1] = $event.checked ? 'No' : ''">
                                        No
                                    </mat-checkbox>
                                </div>
                            </div>

                            <div class="marketing-question">
                                <span class="question-text">
                                    2. Is there any feature of insurance products/ investment/ solutions being highlighted?
                                </span>

                                <div class="question-options">
                                    <mat-checkbox [checked]="marketingAnswers[2] === 'Yes'"
                                        (change)="marketingAnswers[2] = $event.checked ? 'Yes' : ''">
                                        Yes
                                    </mat-checkbox>

                                    <mat-checkbox [checked]="marketingAnswers[2] === 'No'"
                                        (change)="marketingAnswers[2] = $event.checked ? 'No' : ''">
                                        No
                                    </mat-checkbox>
                                </div>
                            </div>

                            <div class="marketing-question">
                                <span class="question-text">
                                    3. Is there any General Insurance product being mentioned?
                                </span>

                                <div class="question-options">
                                    <mat-checkbox [checked]="marketingAnswers[3] === 'Yes'"
                                        (change)="marketingAnswers[3] = $event.checked ? 'Yes' : ''">
                                        Yes
                                    </mat-checkbox>

                                    <mat-checkbox [checked]="marketingAnswers[3] === 'No'"
                                        (change)="marketingAnswers[3] = $event.checked ? 'No' : ''">
                                        No
                                    </mat-checkbox>
                                </div>
                            </div>

                        </div> -->
                    </div>

                    <!-- ---- Actions ---- -->
                    <div class="compose-actions">
                        <button type="button" class="btn-submit" (click)="submitForReview()">
                            Submit for verification
                        </button>
                        <button type="button" class="btn-draft" (click)="saveAsDraft()">Save draft</button>
                        <button type="button" class="btn-cancel" (click)="cancel()">Cancel</button>
                    </div>
                </form>
            </div>

            <!-- ═══════════ Preview ═══════════ -->
            <!-- The reviewer's viewer, not a mock social feed: same toolbar, same per-format
                 renderers, so what the submitter checks here is what the reviewer opens. -->
            @if (previewOpen) {
            <div class="preview-pane">

                <div class="preview-head">
                    <div>
                        <h2 class="preview-title">Preview</h2>
                        <p class="preview-sub">Shown exactly as the reviewer will see it.</p>
                    </div>

                    <button type="button" class="preview-collapse" matTooltip="Collapse preview"
                        (click)="togglePreview()">›</button>
                </div>

                <div class="media-toolbar">
                    @if (materials.length > 1) {
                    <div class="segmented">
                        @for (material of materials; track material.attachment.id) {
                        <button type="button" class="segmented-btn" [class.is-on]="activeMaterial === $index"
                            [matTooltip]="material.attachment.fileName" (click)="selectMaterial($index)">
                            {{ material.format }}
                        </button>
                        }
                    </div>
                    } @else if (preview) {
                    <span class="media-single">{{ preview.attachment.fileName }}</span>
                    }

                    @if (preview && preview.kind !== 'image') {
                    <a class="media-open" [href]="preview.attachment.url" target="_blank" rel="noopener noreferrer"
                        matTooltip="Open in a new tab">
                        <mat-icon>open_in_new</mat-icon>
                    </a>
                    }

                    @if (isZoomable) {
                    <div class="zoom-control">
                        <button type="button" aria-label="Zoom out" [disabled]="!canZoomOut"
                            (click)="zoomOut()">−</button>
                        <span class="zoom-value">{{ zoom }}%</span>
                        <button type="button" aria-label="Zoom in" [disabled]="!canZoomIn" (click)="zoomIn()">+</button>
                    </div>
                    }
                </div>

                @if (!preview) {
                <div class="media-unsupported">
                    <mat-icon>upload_file</mat-icon>
                    <p>Attach the marketing material to see it previewed here.</p>
                </div>
                } @else {
                <div class="media-frame">
                    @switch (preview.kind) {

                    @case ('image') {
                    <div class="media-plate" [style.width.px]="canvasWidth">
                        <img [src]="preview.attachment.url" [alt]="preview.attachment.fileName" />
                    </div>
                    }

                    @case ('pdf') {
                    <div class="media-plate is-doc" [style.width.px]="canvasWidth">
                        <iframe [src]="preview.safeUrl" [title]="preview.attachment.fileName"></iframe>
                    </div>
                    }

                    @case ('video') {
                    <div class="media-plate is-video">
                        <video [src]="preview.attachment.url" controls preload="metadata"></video>
                        <p class="media-note">{{ preview.attachment.fileName }} · {{ preview.meta }}</p>
                    </div>
                    }

                    <!-- Word, Excel and PowerPoint have no in-browser renderer. -->
                    @default {
                    <div class="media-doc" [attr.data-tone]="preview.tone">
                        <span class="media-doc-disc">
                            <mat-icon>{{ preview.icon }}</mat-icon>
                        </span>
                        <p class="media-doc-name">{{ preview.attachment.fileName }}</p>
                        <p class="media-doc-meta">{{ preview.meta }}</p>
                        <p class="media-note">
                            This format cannot be rendered in the browser. Open it to check the material
                            before submitting — the reviewer will see the same file.
                        </p>
                        <a class="media-doc-open" [href]="preview.attachment.url" target="_blank"
                            rel="noopener noreferrer">
                            <mat-icon>open_in_new</mat-icon> Open file
                        </a>
                    </div>
                    }
                    }
                </div>
                }
            </div>
            }
        </div>
    </div>
</app-pias-layout>